import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles({
  firstdiv: {
    marginTop: '16px',
    padding: '16px',
    marginBottom: '16px',
  },
  calc: {
    position: 'relative',
  },
  link: {
    display: 'flex',
    justifyContent: 'center',
  },
});

function Calculator(props) {
  const classes = useStyles();
  const calculator = useRef();
  // const linkroute = useCallback(
  //   () => history.push(props.calculator.route),
  //   [history]
  // );
  const handleClick = (e) => {
    if (!calculator.current?.contains(e.target)) {
      if (calculator.current) {
        calculator.current.style = 'box-shadow: none;transform: scale(1);';
      }
    }
  };

  window.addEventListener('mousedown', handleClick, false);

  window.addEventListener('scroll', () => {
    if (calculator.current) {
      calculator.current.style = 'box-shadow: none;transform: scale(1);';
    }
  });
  return (
    <>
      <Grid
        items
        md={4}
        className={`shadowCol ${classes.firstdiv}`}
        data-category={props.calculator.category}
      >
        <div
          ref={calculator}
          className={`calculator ${classes.calc}`}
          id={props.calculator.name}
        >
          <h5 style={{ textAlign: 'center' }}>{props.calculator.name}</h5>
          <div style={{ overflow: 'auto' }}>
            <p className="calc-box"> {props.calculator.content}</p>
          </div>

          <Link to={props.calculator.route} className={`btn ${classes.link}`}>
            <i className="bx bxs-calculator" style={{ fontSize: '1.4rem' }}></i>
          </Link>
        </div>
      </Grid>
    </>
  );
}

export default Calculator;
